import { HttpClient } from '../../../application/protocols/http-client';
import { AxiosAuthHttpClientAdapter } from './axios-auth-http-client-adapter';

export const authHttpClient: HttpClient = new AxiosAuthHttpClientAdapter();
